export default "__VITE_ASSET__DvA4neA6__"